// Sabit üretim fişi tanımla / düzenle penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'production.fixedOrderForm';

export const productionFixedOrderFormGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Sabit üretim fişi nasıl tanımlanır?'),
  intro: t(`${G}.intro`, 'Sabit üretim fişi, her gün aynı miktarda ürettiğiniz ürün için hazır bir tanımdır (ör. Lahmacun Harcı 14,85 kg). Tanımı bir kez yaparsınız; sonra Üretim Fişleri sayfasındaki "Sabit Üretimler" bölümünden tek tıkla üretirsiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Sabit üretim fişi'),
    body: t(`${G}.regions.body`, 'Şubeler, depolar, miktar'),
    footer: t(`${G}.regions.footer`, 'Vazgeç / Kaydet'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Pencereyi açın'),
      text: t(`${G}.s1.text`, 'Basit Üretim Reçeteleri listesinde reçete satırındaki ⋮ düğmesine basıp "Sabit üretim fişi tanımla"yı seçin. Ürün reçeteden gelir ve değiştirilemez. Menü yalnız üretim modülü açıksa görünür; pasif reçetede seçenek kapalıdır.'),
      tips: [
        t(`${G}.s1.tip1`, 'Düzenleme Üretim Fişleri › Sabit Üretimler sekmesinde ⋮ › Düzenle ile yapılır. Düzenleme penceresi tek kaydı açar: tek girdi/çıktı deposu ve şube gösterir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Şubeleri ve depoları seçin'),
      text: t(`${G}.s2.text`, '"Şubeler" kutusuna yazarak şube arayın ve bir ya da birden çok şube seçin; seçilen her şube için ayrı bir sabit üretim tanımlanır. Listenin başındaki "Tüm şubeler" deposu olan bütün şubeleri seçer, tekrar tıklayınca seçimi temizler. Seçilen her şube altta bir satır olur: "Girdi deposu" malzemelerin düşeceği, "Çıktı deposu" ürünün gireceği depodur. Satırı × ile kaldırabilirsiniz.'),
      tips: [
        t(`${G}.s2.tip1`, 'Depolar kendiliğinden gelir: şubenin varsayılan deposu, yoksa tek deposu, birden çok depo varsa adına göre ilki. Çıktı deposu girdiyle aynı gelir; ikisini de değiştirebilirsiniz.'),
        t(`${G}.s2.tip2`, 'Yalnız en az bir deposu olan şubeler listelenir; akıllı (WMS) depolar listede yoktur. Şube yöneticisi yalnız kendi şubesini ve depolarını görür.'),
        t(`${G}.s2.tip3`, 'Tek seferde en fazla 200 şube kaydedilebilir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Bir üretimdeki miktar'),
      text: t(`${G}.s3.text`, 'Varsayılan değer reçetenin çıktı miktarıdır; isterseniz değiştirin. Ondalık için virgül kullanın (ör. 14,85). Üretirken "Kaç kez?" sorulur; üretilen miktar bu miktar × kaç kez olur.'),
      tips: [
        t(`${G}.s3.tip1`, 'Malzeme listesi sabit fişte saklanmaz. Reçeteyi değiştirirseniz sonraki üretim yeni reçeteyle yapılır.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Ad, not, durum ve Kaydet'),
      text: t(`${G}.s4.text`, '"Ad", miktar, "Not" ve Aktif/Pasif seçimi tüm şubeler için ortaktır. Ad boşsa listede ürün adı görünür. Not, açılan her fişin notuna eklenir. Pasif sabit fiş listede kalır ama üretilemez. "Kaydet"e basın; tüm şubeler tek seferde kaydedilir.'),
      tips: [
        t(`${G}.s4.tip1`, 'Aynı ürün aynı girdi ve çıktı deposuyla zaten tanımlıysa o şube atlanır; kayıttan sonra kaç şubenin tanımlandığı ve hangilerinin atlandığı yazılır.'),
        t(`${G}.s4.tip2`, 'Bir şubede hata varsa (ör. depo yetkisi) hiçbir şube kaydedilmez; pencerenin üstündeki kırmızı mesaj hangi şubede sorun olduğunu söyler.'),
      ],
    },
  ],
});
